import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import moment from "moment";
import Card from "./Layout/Card";
import TeaserImgEvent from "../components/TeaserImgEvent";
import Checkfront from "../components/Checkfront";
import { Link } from "gatsby";
import { FirebaseContext } from "./Firebase"

import { withStyles } from '@material-ui/core/styles';

import Star from '@material-ui/icons/Star';
import StarBorder from '@material-ui/icons/StarBorder';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

const YellowCheckbox = withStyles({
  root: {
    color: '#FCC02E',
    '&$checked': {
      color: '#FCC02E',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const TabAccordion = styled.div`
  input {
    display: none;
  }

  label {
    display: block;
    cursor: pointer;
  }

  input + label + .content {
    display: none;
  }

  input:checked + label + .content {
    display: block;
  }

  h4 {
    font-size: 1.6em;
    color: #ffffff;
  }

  a {
    text-decoration: none;
    color: #ffffff;
  }
`;

const SubEvents = ({ subeventNodes, justStared }) => {
  const { user, firebase } = useContext(FirebaseContext)
  const [checked, setChecked] = useState({'1':false})

  //Checkbox selected events 
  const handleChange = (e) => {
    setChecked({...checked, [e.target.getAttribute('name')] : e.target.checked });
  }

  //Push to DB if checked changed 
  useEffect(() => {
    if(user !== null && user.uid !== null) {
      firebase.updateProfile({uid: user.uid, username: null, bookingNo: null, events: checked})
      .catch(error => {
        console.log(error)
      })
    } 
  }, [checked]);  

  //Update initial check set with saved events from database 
  useEffect(() => {
    if(user !== null && user.events !== null) {
      setChecked(user.events);
    }      
  }, [user])

  //Extract times and day  ... THIS isn't nice
  subeventNodes.forEach((subevent) => {
    subevent.node.data.attributedDay = moment(subevent.node.data.start_datetime_subevent).subtract(8,'hours').format("YYYY-MM-DD")
    subevent.node.data.starttime = subevent.node.data.start_datetime_subevent.split("T")[1].split(":")[0] + ":" + subevent.node.data.start_datetime_subevent.split("T")[1].split(":")[1];
    subevent.node.data.endtime = subevent.node.data.end_datetime_subevent.split("T")[1].split(":")[0] + ":" + subevent.node.data.end_datetime_subevent.split("T")[1].split(":")[1];
  });

  //Day filtered
  const dayFiltered = Object.values(
    subeventNodes.reduce((acc, x) => { acc[x.node.data.attributedDay] = [...(acc[x.node.data.attributedDay] || []), x];
      return acc;
    }, {})
  );

  return (
    <React.Fragment>
        {(user === null) &&
          <Card backgroundcolor="#FCC02E" color="#000000">
            <p>
              Please <Link to="/login">login</Link> and tab stars to create your personal event list
            </p>
          </Card>
        }
        {dayFiltered.map((subArray) => (
        <React.Fragment key={subArray[0].node.data.attributedDay}>
            {/* start day of subevent */}
            <Card backgroundcolor="#52c2f0" color="#FFFFFF">
              <h3>
                {moment(subArray[0].node.data.attributedDay).format("DD.MM.YYYY")}
              </h3>
            </Card>
            
            {/* subevents of that day */}
            {subArray.map((subeventNode) => (
        
            <React.Fragment key={subeventNode.node.id}>
                {/* Not logged in  */}
                {((checked[subeventNode.node.id] === false || checked[subeventNode.node.id] === undefined) && justStared === true) ? (
                  <React.Fragment></React.Fragment>
                ) : (
                  <Card backgroundcolor="#000000" color="#52c2f0">                
                  <TabAccordion>
                      <input type="checkbox" id={subeventNode.node.id} />
                      <label htmlFor={subeventNode.node.id}>
                        <p>{subeventNode.node.data?.starttime || "TBA"} - {subeventNode.node.data?.endtime || ""}</p>
                        
                        <Grid container direction="row" justify="flex-start" alignItems="center">
                          <FormControlLabel
                              control={<YellowCheckbox 
                              icon={<StarBorder fontSize="large" />} 
                              checkedIcon={<Star fontSize="large" />} 
                              onChange={handleChange} 
                              name={subeventNode.node.id} 
                              checked={checked[subeventNode.node.id] || false} 
                              />} 
                          />                          
                          <Typography variant="h4">{subeventNode.node.data?.name_subevent || "no name yet"}</Typography> 
                        </Grid>
                        <p style={{float: 'left'}}>{subeventNode.node.data?.venue_name_from_venue_subevent || "no venue yet"}</p>
                        
                        {subeventNode.node.data.checkfront_sub_total ? (
                          <p style={{float: 'right', color: '#FCC02E'}}>ticket: {subeventNode.node.data.checkfront_sub_total}€</p>
                        ) : (
                          <p style={{float: 'right'}}>more</p>
                        )}
                        
                        <div style={{clear: 'both'}}></div>
                      </label>

                      <div className="content">
                        {subeventNode.node.data.checkfront_sub_total ? (
                          <Checkfront checkfont_subevent={subeventNode.node.data?.checkfont_subevent || "-"} 
                          checkfront_name={subeventNode.node.data?.checkfront_name || "-"} 
                          checkfront_sub_total={subeventNode.node.data?.checkfront_sub_total || "-"}/>
                        ) : (
                          <></>
                        )}

                        <Card backgroundcolor="#000000" color="#52c2f0">                
                        </Card>

                        {subeventNode.node.data.teaser_img_subevent ? (
                            <TeaserImgEvent teaser_img_event={subeventNode.node.data.teaser_img_subevent}/>
                        ) : (
                            <></>
                        )}

                        <Card backgroundcolor="#000000" color="#52c2f0">                
                        </Card>

                        <p>{subeventNode.node.data?.desc_subevent || ""}</p>
                        <p>Genre: <Link to={`/${subeventNode.node.data.url_slug_genre_from_genre_subevent}`}>{subeventNode.node.data.genre_name_from_genre_subevent || ""}</Link></p>
                        <p>Venue: <Link to={`/${subeventNode.node.data.url_slug_venue_from_venue_subevent}`}>{subeventNode.node.data.venue_name_from_venue_subevent || ""}</Link></p>
                      </div>
                  </TabAccordion>
                  </Card>
                )}
            </React.Fragment>
            ))}
        </React.Fragment>
        ))}
    </React.Fragment>
  );
};

export default SubEvents;
